"use strict";
exports.__esModule = true;
exports.createExtraBasketSession = exports.createExtraBasket = exports.createExtra = void 0;
exports.createExtra = function (payload) {
    return {
        extraId: payload.extraId,
        rateId: payload.rateId,
        productId: payload.productId,
        offerId: payload.offerId,
        name: payload.name,
        isMandatory: payload.isMandatory,
        isPreselected: payload.isPreselected,
        summary: payload.description.summary,
        pictures: payload.description.pictures,
        counting: payload.description.counting,
        type: payload.description.type,
        gratuitousnessType: payload.gratuitousnessType,
        price: payload.price,
        taxes: payload.taxes,
        items: payload.items,
        sortOrder: payload.sortOrder
    };
};
exports.createExtraBasket = function (payload) {
    return {
        extraId: payload.extraId,
        productId: payload.productId,
        offerId: payload.offerId,
        name: payload.name,
        availableQuantity: payload.availableQuantity,
        selectedQuantity: payload.selectedQuantity,
        price: payload.price,
        unitPrice: payload.unitPrice,
        "class": payload.description["class"],
        countingType: payload.description.countingType,
        gratuitousnessType: payload.description.gratuitousnessType,
        isMandatory: payload.description.isMandatory,
        isPreselected: payload.description.isPreselected,
        maximumQuantity: payload.description.maximumQuantity,
        occupancyDefinition: payload.description.occupancyDefinition,
        payOnline: payload.description.payOnline,
        pictures: payload.description.pictures,
        sortOrder: payload.description.sortOrder,
        stock: payload.description.stock,
        summary: payload.description.summary,
        type: payload.description.type
    };
};
exports.createExtraBasketSession = function (payload) {
    return {
        extraId: payload.extraId,
        originalPriceAtSelection: payload.originalPriceAtSelection,
        quantity: payload.quantity
    };
};
//# sourceMappingURL=extra.js.map